import React, { useEffect, useState } from 'react';
import { getStudentPayments } from '../services/studentPaymentService';
import Navbar from "../components/studentnavbar";
import Sidebar from '../components/studentsidebar';
import { useSidebar } from '../components/SidebarContext';



const containerStyle = {
  padding: '50px',
  fontFamily: 'Arial, sans-serif',
  textAlign: 'center',
};

const tableContainerStyle = {
  overflowX: 'auto',
  margin: '0 auto',
}

const titleStyle = {
  fontSize: '24px',
  fontWeight: 'bold',
  marginBottom: '20px',
  textAlign: 'center',
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  margin: '0 auto',
};

const thStyle = {
  border: '1px solid #ddd',
  padding: '10px',
  backgroundColor: '#f2f2f2',
  textAlign: 'center',
};

const tdStyle = {
  border: '1px solid #ddd',
  padding: '10px',
  textAlign: 'center',
};

function StudentPayments() {
  const [payments, setPayments] = useState([]);
 const { isSidebarOpen } = useSidebar();
  const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  useEffect(() => {
    async function fetchPayments() {
      try {
        const data = await getStudentPayments(); // ✅ correct
        setPayments(data);
      } catch (error) {
        console.error('Failed to fetch student payments:', error);
      }
    }

    fetchPayments();
  }, []);

  

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Navbar />
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <Sidebar  />
        <div
          style={{
            marginLeft: sidebarWidth,
          width: `calc(100% - ${sidebarWidth})`,
          transition: 'all 0.3s ease',
        
            padding: '20px',
            overflowY: 'auto',
          }}
        >
          <div style={containerStyle}>
            <h2 style={titleStyle}></h2>
            <div style={tableContainerStyle}>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>Amount</th>
                    <th style={thStyle}>Date</th>
                    <th style={thStyle}>Method</th>
                    <th style={thStyle}>Transaction ID</th>
                    <th style={thStyle}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((payment, index) => (
                    <tr key={index}>
                      <td style={tdStyle}>{payment.amount}</td>
                      <td style={tdStyle}>{payment.date}</td>
                      <td style={tdStyle}>{payment.method}</td>
                      <td style={tdStyle}>{payment.transactionId}</td>
                      <td style={tdStyle}>{payment.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentPayments;